<script lang="ts">
import { useFilterStub } from './filter-stub';
import { LocalFilterModel } from './FilterBigInt.vue';
</script>

<script setup lang="ts">
defineExpose(
  useFilterStub<bigint, LocalFilterModel>(
    {
      filter: '',
      type: 'equals',
    },
    ({ filter }) => filter !== '',
    ({ filter, type }, value) => {
      if (filter === '') return true;
      switch (type) {
        case 'equals':
          return value === filter;
        case 'greaterThan':
          return value > filter;
        case 'greaterThanOrEqual':
          return value >= filter;
        case 'lessThan':
          return value < filter;
        case 'lessThanOrEqual':
          return value <= filter;
      }
    }
  )
);
</script>

<!-- eslint-disable-next-line vue/valid-template-root -->
<template></template>
